export const TokenConstants = {
  TOKEN_KEY: 'access_token',
  REFRESH_TOKEN: 'refresh_token'
};
